module.exports = __webpack_public_path__ + "media/colis-deja-au-depot.dc0aa1a0.mp3";